import { render, staticRenderFns } from "./ProviderDeleteDialog.vue?vue&type=template&id=cfabddb6"
import script from "./ProviderDeleteDialog.vue?vue&type=script&lang=js"
export * from "./ProviderDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports